import * as React from 'react';
import styled from 'styled-components';
import GoogleMapReact from 'google-map-react';
import { Marker } from './Marker';

const MapViewContainer = styled.div`
  width: 100%;
`;

interface center {
  lat: number;
  lng: number;
}

interface props {
  center: center;
  zoom: number;
  style?: React.CSSProperties;
}

class MapView extends React.Component<props, any> {
  static defaultProps = {
    center: {
      lat: 39.95427960000001,
      lng: -75.20148929999999,
    },
    zoom: 17,
  };

  render() {
    return (
      <MapViewContainer style={this.props.style}>
        <GoogleMapReact
          // found a temporary API key on Github xd :)
          bootstrapURLKeys={{ key: 'AIzaSyDTXLuaT-wa8hi0MZlChQdvQNSyiYqxTBg' }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Marker lat={this.props.center.lat} lng={this.props.center.lng} text={null} />
        </GoogleMapReact>
      </MapViewContainer>
    );
  }
}

export default MapView;



// WEBPACK FOOTER //
// ./src/components/MapView.tsx